export default {
  'Confirmed Entries': {
    status: 'approved',
  },
  'Pending Entries': {
    status: 'pending',
  },
  'Rejected Entries': {
    status: 'rejected',
  },
  'View All': {
    status: ['pending', 'approved', 'rejected'],
  },
};
